import type { PrintSettings } from '~/renderer/store/hub/types';

export const defaultPrintSettings: PrintSettings = {
  isCustomized: false,
  isDithered: false,
  brightness: 0,
};
